<mat-toolbar class="jlc-toolbar">
  <a class="logo-link" routerLink="/" aria-label="Ir al inicio">
    <img [src]="marca.logo" [alt]="marca.nombre" class="logo-img-plain" />
  </a>

  <!-- Botón hamburguesa — solo visible en móvil -->
  <button mat-icon-button class="nav-hamburger" [matMenuTriggerFor]="navMenu" aria-label="Navegación">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Menú desplegable para móvil -->
  <mat-menu #navMenu="matMenu">
    <a mat-menu-item routerLink="/mapa"><mat-icon>map</mat-icon><span>Mapa</span></a>
    <a mat-menu-item routerLink="/entidades"><mat-icon>domain</mat-icon><span>Entidades</span></a>
    <a mat-menu-item routerLink="/actores"><mat-icon>people</mat-icon><span>Actores</span></a>
    <a mat-menu-item routerLink="/encargos"><mat-icon>work</mat-icon><span>Encargos</span></a>
    <a mat-menu-item *ngIf="(isSuperUser || isAdmin) && !isSimulating" routerLink="/interacciones"><mat-icon>forum</mat-icon><span>Interacciones</span></a>
    <a mat-menu-item routerLink="/documentos"><mat-icon>description</mat-icon><span>Documentos</span></a>
    <a mat-menu-item routerLink="/comments"><mat-icon>chat_bubble</mat-icon><span>Comentarios</span></a>
    <a mat-menu-item *ngIf="env.features.facturacion" routerLink="/facturas"><mat-icon>receipt_long</mat-icon><span>Facturas</span></a>
    <a mat-menu-item routerLink="/fotos"><mat-icon>photo_library</mat-icon><span>Fotos</span></a>
    <a mat-menu-item *ngIf="env.features.comunicaciones && (isSuperUser || isAdmin) && !isSimulating" routerLink="/comunicaciones"><mat-icon>campaign</mat-icon><span>Comunicaciones</span></a>
  </mat-menu>

  <!-- Navegación desktop -->
  <nav class="nav-items" aria-label="Navegación principal">
    <a mat-button routerLink="/mapa" routerLinkActive="active">Mapa</a>
    <a mat-button routerLink="/entidades" routerLinkActive="active">Entidades</a>
    <a mat-button routerLink="/actores" routerLinkActive="active">Actores</a>
    <a mat-button routerLink="/encargos" routerLinkActive="active">Encargos</a>
    <a *ngIf="(isSuperUser || isAdmin) && !isSimulating" mat-button routerLink="/interacciones" routerLinkActive="active">Interacciones</a>
    <a mat-button routerLink="/documentos" routerLinkActive="active">Documentos</a>
    <a mat-button routerLink="/comments" routerLinkActive="active">Comentarios</a>
    <a *ngIf="env.features.facturacion" mat-button routerLink="/facturas" routerLinkActive="active">Facturas</a>
    <a mat-button routerLink="/fotos" routerLinkActive="active">Fotos</a>
  </nav>

  <span class="spacer"></span>
  
  <mat-form-field *ngIf="env.features.globalSearch" appearance="outline" subscriptSizing="dynamic" class="gn-top-search" (keydown)="onKeydown($event)" (keydown.enter)="$event.preventDefault()">
    <mat-icon matPrefix>search</mat-icon>
    <input #globalSearchInput matInput [formControl]="ctrl" placeholder="Buscar encargos, documentos…" autocomplete="off" [matAutocomplete]="auto" (input)="onInput($event)">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="go($event.option.value)" [displayWith]="displayHit" autoActiveFirstOption="true">
      <mat-option *ngFor="let r of results$ | async" [value]="r">
        <div class="gn-search-row">
          <mat-icon class="gn-search-icon">{{ r.icon }}</mat-icon>
          <div class="gn-search-col">
            <div class="gn-search-title">{{ r._title }}</div>
            <div class="gn-search-subtitle">{{ typeLabel(r._type) }}{{ r._subtitle ? ' — ' + r._subtitle : '' }}</div>
          </div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <ng-container>

    <!-- Ayuda de la pantalla actual — visible en desktop y móvil -->
    <button mat-icon-button class="help-btn" (click)="openAyuda()" aria-label="Ayuda de esta pantalla" matTooltip="Ayuda de esta pantalla">
      <mat-icon>help_outline</mat-icon>
    </button>

    <div class="user-info">
      <img *ngIf="user?.photoURL" [src]="user?.photoURL" class="avatar" alt="avatar" />
      <span *ngIf="!user?.photoURL" class="avatar avatar--initials">
        {{ getInitials(actorNombre || user?.displayName, user?.email) }}
      </span>
      <span class="user-name">{{ actorNombre || user?.displayName || user?.email }}</span>
    </div>

    <!-- Logout directo — solo visible en móvil -->
    <button mat-icon-button class="logout-direct" (click)="logout()" aria-label="Cerrar sesión">
      <mat-icon>logout</mat-icon>
    </button>

    <!-- Menú de usuario — solo visible en desktop -->
    <button mat-icon-button class="user-menu-btn" [matMenuTriggerFor]="menu" aria-label="Menú usuario">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openPerfil()">
        <mat-icon>account_circle</mat-icon>
        <span>Perfil</span>
      </button>
      <button mat-menu-item *ngIf="env.features.comunicaciones" (click)="openComunicacionesRecibidas()">
        <mat-icon>mark_email_read</mat-icon>
        <span>Comunicaciones recibidas</span>
      </button>
      <button mat-menu-item disabled *ngIf="isSuperUser">
        <mat-icon>settings</mat-icon>
        <span>Configuración</span>
      </button>
      <mat-divider></mat-divider>
      <a mat-menu-item *ngIf="env.features.comunicaciones && (isSuperUser || isAdmin) && !isSimulating" routerLink="/comunicaciones">
        <mat-icon>campaign</mat-icon>
        <span>Comunicaciones</span>
      </a>
      <button mat-menu-item *ngIf="isSuperUser && env.features.facturacion && !isSimulating" (click)="exportarVeriFactu()">
        <mat-icon>archive</mat-icon>
        <span>Exportar XMLs VeriFactu</span>
      </button>
      <mat-divider *ngIf="(isSuperUser || isAdmin) && !isSimulating"></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </ng-container>
</mat-toolbar>
